import { render, staticRenderFns } from "./form-snippet-list.vue?vue&type=template&id=68e6232a&scoped=true&"
import script from "./form-snippet-list.vue?vue&type=script&lang=js&"
export * from "./form-snippet-list.vue?vue&type=script&lang=js&"
import style0 from "./form-snippet-list.vue?vue&type=style&index=0&id=68e6232a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e6232a",
  null
  
)

export default component.exports